import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';
import { Box } from '@mui/material';

interface LabelProps extends PropsWithChildren {
  color: 'default' | 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error';
  variant: 'filled' | 'outlined' | 'ghost' | 'soft';
  startIcon?: ReactElement;
  endIcon?: ReactElement;
}

export const Label: FunctionComponent<LabelProps> = ({ variant = 'soft', endIcon, startIcon, color, children }) => {
  // Tailwind v4 removed bg-opacity-*, so the soft variant uses the /20 colour variants instead
  const soft = variant === 'soft';
  const iconStyle = {
    width: 16,
    height: 16,
    '& svg, img': { width: 1, height: 1, objectFit: 'cover' },
  };

  return (
    <div
      className={`inline-flex h-5 items-center justify-center  rounded-md px-2 text-xs font-semibold leading-none tracking-wide
      ${soft ? 'bg-gray-700/20' : 'bg-gray-700'}
      ${color === 'primary' ? `${soft ? 'bg-primary-600/20' : 'bg-primary-600'} text-primary-600` : ''}
      ${color === 'success' ? `${soft ? 'bg-green-600/20' : 'bg-green-600'} text-green-600` : ''}
      ${color === 'info' ? `${soft ? 'bg-blue-600/20' : 'bg-blue-600'} text-blue-600` : ''}
      ${color === 'error' ? `${soft ? 'bg-red-600/20' : 'bg-red-600'} text-red-600` : ''}
      ${color === 'warning' ? `${soft ? 'bg-yellow-600/20' : 'bg-yellow-600'} text-yellow-600` : ''}
      `}
      style={{ minWidth: '22px' }}
    >
      {startIcon && <Box sx={{ mr: 0.75, ...iconStyle }}> {startIcon} </Box>}

      {children}

      {endIcon && <Box sx={{ ml: 0.75, ...iconStyle }}> {endIcon} </Box>}
    </div>
  );
};
